/**
 * HTTP failure from originator/provider/custodian APIs.
 * `code` is the backend domain code when present (e.g. ADM-001).
 */
export class ApiError extends Error {
  constructor(message, { status, code, payload } = {}) {
    super(message);
    this.name = 'ApiError';
    this.status = status ?? null;
    this.code = code ?? null;
    this.payload = payload ?? null;
  }
}

export function isStaleAdmissionError(error) {
  if (!error) return false;
  if (error.code === 'STALE_ADMISSION_CONTEXT') return true;
  const message = String(error.message || '');
  return /admission assessment has changed/i.test(message);
}

export const STALE_ADMISSION_MESSAGE = 'Submission changed; review updated facts.';

export function formatApiFailure(error, fallback = 'Request failed.') {
  const message =
    error && typeof error.message === 'string' && error.message.trim()
      ? error.message.trim()
      : fallback;
  const code = error && typeof error.code === 'string' ? error.code.trim() : '';
  if (code && !message.startsWith(`${code}:`) && message !== code) {
    return `${code}: ${message}`;
  }
  return message;
}
